import { render } from "./shelves.vue?vue&type=template&id=1b536b9a&scoped=true"
import script from "./shelves.vue?vue&type=script&lang=js"
export * from "./shelves.vue?vue&type=script&lang=js"

import "./shelves.vue?vue&type=style&index=0&id=1b536b9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b536b9a"]])

export default __exports__